// extracted by mini-css-extract-plugin
module.exports = {"Loader":"spinner_Loader__1cehF","load2":"spinner_load2__1hc4q"};